const PropTypes = require('prop-types');
const React = require('react');
const UrlHelpers = require('components/shared/url_helpers.js');
const ReactDOMServer = require('react-dom/server');
const PriceDisplay = require('components/shared/price_display.jsx');
const ShippingPrice = require('components/listings/shipping_price.jsx');
const classNames = require('classnames');

class ModalProductSummary extends React.Component {
  get proceedToCheckoutText() {
    return I18n.t('js.addToCart.successModal.proceedToCheckout', { count: this.itemsBundledCount });
  }

  get itemsBundledCount() {
    if (this.cartItem.acceptsDirectCheckout) {
      return this.props.directCheckoutCartCount;
    }
    return 1;
  }

  get cartItem() {
    return this.props.cartItem;
  }

  get checkoutPath() {
    return this.cartItem.preferredCheckoutLink;
  }

  get proceedToCheckoutButton() {
    if (this.props.zeroPercentAffirmFinancing) { return null; }

    return (
      <a
        id="proceed-to-checkout"
        href={this.checkoutPath}
        className="cart-modal-actions__action cart-modal-actions__action--primary"
      >
        {this.proceedToCheckoutText}
      </a>
    );
  }

  isOnSale() {
    return this.cartItem.eligibleSale;
  }

  renderCartActions() {
    if (!this.props.showActions) { return null; }

    return (
      <div className="cart-modal-actions">
        <a
          id="view-cart"
          href={UrlHelpers.cartPath}
          className={classNames('cart-modal-actions__action', { 'cart-modal-actions__action--primary': this.props.zeroPercentAffirmFinancing })}
        >
          {I18n.t('js.addToCart.successModal.viewCart')}
        </a>
        {this.proceedToCheckoutButton}
      </div>
    );
  }

  renderShopLink() {
    const link = (
      <a
        href={this.cartItem._links.seller.web.href}
        className="muted"
      >
        {this.cartItem.shopName}
      </a>
    );
    const translation = I18n.t('js.addToCart.successModal.soldBy', {
      shop_link: ReactDOMServer.renderToString(link),
    });

    return (
      <p
        className="size-80 truncate show-only-on-desktop mb-0"
        dangerouslySetInnerHTML={{ __html: translation }}
      />
    );
  }

  renderPlaceholder() {
    return (
      <div className="loading-placeholder-content">
        <div className="g-container">
          <div className="g-col-2">
            <div className="placeholder-image fluid-square" />
          </div>
          <div className="g-col-4 g-col-mobile-6">
            <div className="placeholder-p mb-1" />
            <div className="placeholder-p quarter-width mtb-half" />
          </div>
          <div className="g-col-6 g-col-mobile-4">
            <div className="align-right">
              <div className="placeholder-p quarter-width inline-block" />
              <br />
              <div className="placeholder-p quarter-width inline-block mb-1" />
              <br />
              <div className="show-only-on-desktop">
                <div className="placeholder-btn size-large inline-block mr-half" />
                <div className="placeholder-btn size-large inline-block" />
              </div>
            </div>
          </div>
        </div>
        <div className="mt-1 show-only-on-mobile">
          <div className="placeholder-btn size-large wide mb-1" />
          <div className="placeholder-btn size-large wide" />
        </div>
      </div>
    );
  }

  renderSaleReminder() {
    if (this.isOnSale()) {
      return (
        <p className="cart-sale-reminder">
          {this.cartItem.saleReminderText}
        </p>
      );
    }
    return null;
  }

  renderOriginalPrice() {
    if (!this.cartItem.originalItemPrice) { return null; }

    return (
      <p className="muted truncate mb-0">
        <strike>
          <PriceDisplay
            price={this.cartItem.originalItemPrice}
            showCurrency={false}
          />
        </strike>
      </p>
    );
  }

  renderPrice() {
    const price = this.cartItem.itemPrice;
    const classnames = classNames('cart-price', {
      'cart-price--on-sale': this.isOnSale(),
    });

    return (
      <p className={classnames}>
        <PriceDisplay price={price} />
      </p>
    );
  }

  render() {
    if (!this.cartItem) { return this.renderPlaceholder(); }

    return (
      <div>
        <div className="g-container">
          <div className="g-col-2">
            <div className="image-box bd-1 bd--offwhite">
              <img
                src={this.cartItem.thumbnail}
                alt={this.cartItem.title}
                className="img-wide img-hoverable bordered bd-rounded"
              />
            </div>
          </div>
          <div className="g-col-4 g-col-mobile-6">
            {this.renderSaleReminder()}
            <p className="lh-130 scaling-mb-half">{this.cartItem.title}</p>
            {this.renderShopLink()}
          </div>
          <div className="g-col-6 g-col-mobile-4">
            <div className="align-right">
              {this.renderOriginalPrice()}
              {this.renderPrice()}
              <p className="muted size-80 mb-0">
                <ShippingPrice shippingRate={this.cartItem.shippingPrice} />
              </p>
              <div className="cart-modal-actions-desktop-wrapper">
                {this.renderCartActions()}
              </div>
            </div>
          </div>
        </div>
        <div className="cart-modal-actions-mobile-wrapper">
          {this.renderCartActions()}
        </div>
      </div>
    );
  }
}

ModalProductSummary.propTypes = {
  cartItem: PropTypes.object,
  zeroPercentAffirmFinancing: PropTypes.bool,
  directCheckoutCartCount: PropTypes.number,
  showActions: PropTypes.bool,
};

ModalProductSummary.defaultProps = {
  zeroPercentAffirmFinancing: false,
  showActions: true,
};

module.exports = ModalProductSummary;



// WEBPACK FOOTER //
// ./javascripts/components/listings/cart/modal_product_summary.jsx